module.exports = __webpack_public_path__ + "img/5-white.00200442.svg";